/**
 * API/DB prizeType → 화면 문구 (인센티브 상금 기준)
 * @param {'displayed'|'actual'|string|null|undefined} type
 */
export const formatPrizeTypeLabel = (type) => {
	if (!type) return '-'
	if (type === 'displayed') return '상금 표기액'
	return '상금 실수령액'
}

/**
 * 폼 incentiveTaxOption(IncentiveModal 값) → 화면 문구
 * @param {'amountDisplayed'|'amountReceived'|string|null|undefined} option
 */
export const formatIncentiveTaxOptionLabel = (option) => {
	if (!option) return '-'
	if (option === 'amountDisplayed') return '상금 표기액'
	return '상금 실수령액'
}

/** 카드·모달·계약 상세에서 prizeType 행 제목 — 값은 상금 표기액 / 상금 실수령액 (급여 세전·세후와 구분) */
export const INCENTIVE_BASIS_LABEL = '적용 상금'
